//create CRUD class with axios
import axios, { AxiosResponse } from "axios";
import dayjs from "dayjs";
import _, { forEach } from "lodash";
import { SETTING_ID } from "@/interface/Setting";
import { promptpay } from "@/modules/core/utils/canvas";

const PRINTER_NAME = "pos8080";

const STYLE_FONT_SIZE = {
  ITEMS: 10,
  GRAND_TOTAL: 14,
  GENERAL_TEXT: 10,
};

const REPLACE_ID = {
  PREVIEW_HEADER: "PREVIEW_HEADER",
  PREVIEW_FOOTER: "PREVIEW_FOOTER",

  RECEIPT_HEADER: "RECEIPT_HEADER",
  RECEIPT_FOOTER: "RECEIPT_FOOTER",
};

export default class ThermalPrinterReceipt extends ThermalPrinterBase {
  async setPrintPreview(payload: any) {
    const settingsStore = useSettingsStore();
    let content = [];
    

    //draw detail header
    content.push(
      {
        type: "text",
        value: `*** ใบตรวจสอบราคาสินค้า ***`,
        style: {
          fontFamily: "Arial",
          fontSize: STYLE_FONT_SIZE.GRAND_TOTAL,
          fontStyle: "normal",
          align: "center",
        },
      },
      {
        type: "newline",
        value: "10",
      },
      {
        replaceId: REPLACE_ID.PREVIEW_HEADER,
        type: "text",
        value: settingsStore.getValueBysettingId(
          SETTING_ID.PRINTER_PREVIEW_HEADER,
          null
        ),
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          align: "center",
        },
      },
      {
        type: "newline",
        value: "10",
      },

      {
        type: "text",
        value: `Date : ${dayjs(payload.createdAt).format(
          "DD/MM/YYYY HH:mm:ss"
        )}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },

      {
        type: "text",
        value: `Cashier : ${payload.employee.name}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },

      {
        type: "text",
        value: `Guests : ${payload.metadata.guests}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },
      { type: "newline", value: "15" },

      {
        type: "text",
        value:
          `${payload.table}` +
          `${this.billSuffix(payload.bill)}`,
        style: {
          fontFamily: "Arial",
          fontSize: 14,
          fontStyle: "bold",
          align: "center",
        },
      },
      {
        type: "newline",
        value: "16",
      },
      { type: "line" }
    );

    debugger

    const isSkipPriceZero = settingsStore.getValueBysettingId(
      SETTING_ID.PRINTER_JOB_SKIP_PRICE_ZERO,
      false
    );

    // draw items
    for(let index = 0; index < payload.items.length; index++) {
      const item = payload.items[index];
      //Skip Price Zero
      if (
        isSkipPriceZero === true &&
        item.price == 0 &&
        item.addOnPrice === 0
      ) {
        //add on price is topping total amount
        continue
      }

      content.push({
        type: "text2cols",
        value: `${item.qty} ${item.name}`,
        value2: `${displayCommaMoney(item.extendedPrice, true)}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      });

      if (item.options2 && item.options2.length > 0) {
        item.options2.forEach((option) => {
          content.push({
            type: "text2cols",
            value: `     - ${option.name}  x${option.qty}`,
            value2: ` `,
            style: {
              fontFamily: "Arial",
              fontSize: this.customFontSize().sub,
              fontStyle: "normal",
            },
          });
        });
      }
      const isShowComment = settingsStore.getValueBysettingId(
        SETTING_ID.PRINTER_RECEIPT_COMMENTS,
        false
      );

      if (item.comments && isShowComment) {
        content.push({
          type: "text2cols",
          value: `     # ${item.comments}`,
          value2: ` `,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().sub,
            fontStyle: "normal",
          },
        });
      }

      if (item.dc1[2] != 0 && item.dc1[0] == 0) {
        content.push({
          type: "text2cols",
          value: `     - ส่วนลด ${item.dc1[1]}%`,
          value2: ` `,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().sub,
            fontStyle: "normal",
          },
        });
      }

      if (item.dc1[2] != 0 && item.dc1[0] == 1) {
        content.push({
          type: "text2cols",
          // พิมพ์ยอดที่หักจริง (dc1[2]) ไม่ใช่เรตต่อชิ้น (dc1[1])
          // ใบเสร็จคือยอดที่คิดเงินไปแล้ว ลูกค้าต้องเห็นตัวเลขที่ถูกหักจริง
          // และไม่ต้องพึ่ง discountPerUnit ซึ่งเป็นเรื่องของการ replay โต๊ะที่ยังไม่จ่าย
          value: `     - ส่วนลด ${Math.abs(item.dc1[2])}`,
          value2: ` `,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().sub,
            fontStyle: "normal",
          },
        });
      }

      // add new line if not last item
      if(index < payload.items.length - 1){
        content.push({ type: "newline", value:this.customFontSize().newLine });
      }
    }

    // draw total summary
    this._drawSummary(content, payload);

    // draw Qrcode
    // content.push(
    //     {
    //         type: 'text',
    //         value: `Prompt Pay`,
    //         style: {
    //             fontFamily: 'Arial',
    //             fontSize: 14,
    //             fontStyle: 'bold',
    //             align: 'center'
    //         }
    //     },
    //     {
    //         type: 'qrcode',
    //         value: 'https://www.instagram.com/p.thanyakorn/',
    //         style: {
    //             fontSize: 50,
    //             align: 'center'
    //         }
    //     },
    //     {
    //         type: 'newline',
    //         value: '10'
    //     }
    // )

    // draw footer thanks 
    if (payload.payment?.note) {
      content.push(
        { type: "line" },
        {
          type: "text",
          value: `Note : **${payload.payment?.note || ""}`,
          value2: payload.payment?.note || "",
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().main,
            fontStyle: "normal",
          },
        },       
      );
    }

    content.push({ type: "newline", value:"10" });
    //Show Image
    await this.renderImage(content, SETTING_ID.PRINT_PREVIEW_IMAGE);

    content.push(
      { type: "newline", value:"10" },
      {
        replaceId: REPLACE_ID.PREVIEW_FOOTER,
        type: "text",
        value: settingsStore.getValueBysettingId(
          SETTING_ID.PRINTER_PREVIEW_FOOTER,
          null
        ),
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          align: "center",
        },
      },
      {
        type: "newline",
        value: "10",
      },

      {
        type: "text",
        value: "*** Thank you ***",
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "bold",
          align: "center",
        },
      },
      {
        type: "newline",
        value: "10",
      },      
    );

    //QR Code
    // await this._renderPrintQrCode(content, payload)

    content = this._checkAndRemoveEmptyLine(content);
    let cmd = {
      // printerName : "Cashier01",
      printerPreset: "0",
      jobId: new Date().valueOf().toString(),
      timestamp: new Date().toISOString(),
      date: dayjs().format("YYYY-MM-DD"),
      content: content,
    };
    this.print_queues.push(cmd);
    return this;
  }

  async setReceipt(receiptPayload: any, { shopName, isCopy = false }) {
    const settingsStore = useSettingsStore();
    let content = [];

    this.renderReceiptCopy(content, isCopy);

    //Show Image
    const hasReceiptLogo = await this.renderImage(content, SETTING_ID.RECEIPT_LOGO);

    const showTimeInTimeOutSetting = settingsStore.getValueBysettingId(
      SETTING_ID.PRINTER_SHOW_TIMEIN_TIMEOUT,
      false
    );

    let timeInText = `Time In : ${this.showReceiptTime(
      receiptPayload.metadata?.startDate
    )}`;
    let timeOutText = `Time Out : ${this.showReceiptTime(
      receiptPayload.metadata?.endDate
    )}`;
    if (!showTimeInTimeOutSetting) {
      timeInText = "";
      timeOutText = "";
    }

    //draw detail header
    // มีโลโก้ร้านอยู่แล้วไม่ต้องพิมพ์ชื่อร้านซ้ำ พิมพ์ชื่อร้านเฉพาะตอนที่ไม่มีโลโก้
    if (!hasReceiptLogo && shopName) {
      content.push({
        type: "text",
        value: shopName,
        style: {
          fontFamily: "Arial",
          fontSize: 14,
          fontStyle: "bold",
          align: "center",
        },
      });
    }

    content.push(
      {
        type: "newline",
        value: "10",
      },
      // todo: check if can run multiple lines
      {
        replaceId: REPLACE_ID.RECEIPT_HEADER,
        type: "text",
        value: settingsStore.getValueBysettingId(
          SETTING_ID.PRINTER_RECEIPT_HEADER,
          ""
        ),
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "center",
        },
      },

      {
        type: "newline",
        value: "20",
      },

      {
        type: "text",
        value: `Date : ${dayjs(receiptPayload.createdAt).format(
          "DD/MM/YYYY HH:mm:ss"
        )}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },
      {
        flag: "timeInTimeOut",
        type: "text2cols",
        value: timeInText,
        value2: timeOutText,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },
      {
        type: "text",
        value: `Receipt ID : ${receiptPayload.receiptId}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },
      {
        type: "text",
        value: `Cashier : ${receiptPayload.employee.name}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },
      {
        flag: "numberOfCustomer",
        type: "text",
        value: `Guests : ${receiptPayload.metadata.guests}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
          align: "left",
        },
      },
      { type: "newline", value: "15" },
      {
        type: "text",
        value:
          `${receiptPayload.table}` +
          `${this.billSuffix(receiptPayload.bill)}`,
        style: {
          fontFamily: "Arial",
          fontSize: 14,
          fontStyle: "bold",
          align: "center",
        },
      },
      { type: "newline", value: "16" },
      { type: "line" }
    );

    //Check show time in time out
    if (!showTimeInTimeOutSetting) {
      content = content.filter((c) => {
        if (c.flag == undefined) {
          return c;
        }

        if (c.flag !== "timeInTimeOut") {
          return c;
        }
      });
    }

    //Check show number of customer
    const showNumberOfCustomerSetting = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_SHOW_NUMBER_OF_CUSTOMER, false);
    if (!showNumberOfCustomerSetting) {
      content = content.filter((c) => {
        if (c.flag == undefined) {
          return c;
        }

        if (c.flag !== "numberOfCustomer") {
          return c;
        }
      });
    }

    const isSkipPriceZero = settingsStore.getValueBysettingId(
      SETTING_ID.PRINTER_JOB_SKIP_PRICE_ZERO,
      false
    );

    // // draw items
    for(let index = 0; index < receiptPayload.items.length; index++) {
      const item = receiptPayload.items[index];
      //Skip Price Zero
      if (
        isSkipPriceZero === true &&
        item.price == 0 &&
        item.addOnPrice === 0
      ) {
        //add on price is topping total amount
        continue
      }

      content.push({
        type: "text2cols",
        value: `${item.qty}  ${item.name}`,
        value2: `${displayCommaMoney(item.extendedPrice, true)}`,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      });

      if (item.options2 && item.options2.length > 0) {
        item.options2.forEach((option) => {
          content.push({
            type: "text2cols",
            value: `     - ${option.name}  x${option.qty}`,
            value2: ` `,
            style: {
              fontFamily: "Arial",
              fontSize: this.customFontSize().sub,
              fontStyle: "normal",
            },
          });
        });
      }

      const isShowComment = settingsStore.getValueBysettingId(
        SETTING_ID.PRINTER_RECEIPT_COMMENTS,
        false
      );
      if (item.comments && isShowComment) {
        content.push({
          type: "text2cols",
          value: `     # ${item.comments}`,
          value2: ` `,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().sub,
            fontStyle: "normal",
          },
        });
      }

      if (item.dc1[2] != 0 && item.dc1[0] == 0) {
        content.push({
          type: "text2cols",
          value: `     - ส่วนลด ${item.dc1[1]}%`,
          value2: ` `,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().sub,
            fontStyle: "normal",
          },
        });
      }

      if (item.dc1[2] != 0 && item.dc1[0] == 1) {
        content.push({
          type: "text2cols",
          // พิมพ์ยอดที่หักจริง (dc1[2]) ไม่ใช่เรตต่อชิ้น (dc1[1])
          // ใบเสร็จคือยอดที่คิดเงินไปแล้ว ลูกค้าต้องเห็นตัวเลขที่ถูกหักจริง
          // และไม่ต้องพึ่ง discountPerUnit ซึ่งเป็นเรื่องของการ replay โต๊ะที่ยังไม่จ่าย
          value: `     - ส่วนลด ${Math.abs(item.dc1[2])}`,
          value2: ` `,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().sub,
            fontStyle: "normal",
          },
        });
      }

      //newline 
      if(index < receiptPayload.items.length - 1){
        content.push({ type: "newline", value:this.customFontSize().newLine });
      }
    }

    // // draw total summary
    this._drawSummary(content, receiptPayload);

    let received = receiptPayload.payment.received;
    //parse float
    received = parseFloat(received);

    //change
    let change = receiptPayload.payment.change;
    //parse float
    change = parseFloat(change);
    //abs
    change = Math.abs(change);

    //Receive Payment
    this.renderReceivePayment(content, receiptPayload);
    content.push(  
      { type: "newline", value:this.customFontSize().smallNewLine },
      {
        type: "text2cols",
        value: `Change`,
        value2: displayCommaMoney(change, true),
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine },  
      {
        type: "newline",
        value: "20",
      }
    );
    
    if(receiptPayload.metadata?.room){
      content.push(
        {
          type: "text",
          value: `Room : ${receiptPayload.metadata?.room?.label}`,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().main,
            fontStyle: "normal",
            align: "left",
          },
        },        
      );
    } 

  
    if (receiptPayload.payment?.note) {
      content.push({
        type: "text",
        value: `Note : **${receiptPayload.payment?.note || ""}`,
        value2: receiptPayload.payment?.note || "",

        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      });
    }

   

    content.push({
      type: "newline",
      value: "20",
    });

    //Show Image
    await this.renderImage(content, SETTING_ID.RECEIPT_IMAGE);

    // draw footer thanks
    content.push(
      {
        type: "newline",
        value: "10",
      },
      {
        replaceId: REPLACE_ID.RECEIPT_FOOTER,
        type: "text",
        value: settingsStore.getValueBysettingId(
          SETTING_ID.PRINTER_RECEIPT_FOOTER,
          null
        ),
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,

          align: "center",
        },
      },
      {
        type: "newline",
        value: "10",
      },
      {
        type: "text",
        value: "*** Thank You ***",
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "bold",
          align: "center",
        },
      },
      {
        type: "newline",
        value: "20",
      }
    );

    //QR Code
    //await this._renderPrintQrCode(content, receiptPayload)

    this.renderReceiptCopy(content, isCopy);
    content = this._checkAndRemoveEmptyLine(content);

    let cmd = {
      // printerName : 'Cashier01',
      printerPreset: "0",
      jobId: new Date().valueOf().toString(),
      timestamp: new Date().toISOString(),
      date: dayjs().format("YYYY-MM-DD"),
      content: content,
    };
    this.print_queues.push(cmd);
    return this;
  }

  voidBill(receipt: any) {
    let content = [];
    //draw detail header
    content.push(
      {
        type: "text",
        value: `VOIDED BILL (ยกเลิกบิล)`,
        style: {
          fontFamily: "Arial",
          fontSize: 14,
          fontStyle: "bold",
          align: "center",
        },
      },
      // {
      //     type: 'text',
      //     value: `Your addres sample Header`,
      //     style: {
      //         fontFamily: 'Arial',
      //         fontSize: 10,
      //         fontStyle: 'normal',
      //         align: 'center'
      //     }
      // },
      {
        type: "newline",
        value: "24",
      },
      {
        type: "text",
        value: `Table ${receipt.table}`,
        style: {
          fontFamily: "Arial",
          fontSize: 14,
          fontStyle: "bold",
          align: "center",
        },
      },
      {
        type: "newline",
        value: "16",
      },
      {
        type: "text",
        value: `Receipt ID : ${receipt.receiptId}`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      },
      {
        type: "text",
        value: `Receipt Date : ${dayjs(receipt.createdAt).format(
          "DD/MM/YYYY HH:mm:ss"
        )}`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      },
      {
        type: "text",
        value: `Amount : ${receipt.payment.grandTotal.toFixed(2)}`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      },

      {
        type: "text",
        value: `CASHIER : ${receipt.employee.name}`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      },

      { type: "newline", value: "5" },
      { type: "line" },

      {
        type: "text",
        value: `VOID AT : ${dayjs().format("DD/MM/YYYY HH:mm:ss")}`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      },

      {
        type: "text",
        value: `VOID REASON : ${receipt.voided.reason}`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      },
      { type: "newline", value: "16" },

      {
        type: "text",
        value: `SIGN  : ________________________`,
        style: {
          fontFamily: "Arial",
          fontSize: 10,
          fontStyle: "normal",
          align: "left",
        },
      }
    );

    let cmd = {
      // printerName : 'Cashier01',
      printerPreset: "0",
      jobId: new Date().valueOf().toString(),
      timestamp: new Date().toISOString(),
      date: dayjs().format("YYYY-MM-DD"),
      content: content,
    };
    this.print_queues.push(cmd);
    return this;
  }

  _drawSummary(content, receiptPayload) {
    const settingsStore = useSettingsStore();

    const table = receiptPayload.table;
    const posStore = usePosStore();
    // ใบเสร็จใหม่เก็บอัตราไว้ในตัว (payment.ccSetting) — พิมพ์หลังโต๊ะถูก CLEAR แล้ว tableState ไม่มีค่าเหลือ
    // ใบเก่าที่ไม่มี field นี้ใช้ค่าจาก tableState แบบเดิม
    const _cardCharge = receiptPayload.payment?.ccSetting || posStore.tableState[table]?.cc || [0, 0];
    
    let list = [];
    let summaryList = [];
    const taxMode = settingsStore.getValueBysettingId(SETTING_ID.TAX_MODE,0)
    const showServiceChargePercent = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_SHOW_SERVICE_CHARGE_PERCENT, true);
    const roundingType = settingsStore.getRoundingType;
    // ปัดเศษถูกบวกเข้า grandTotal ไปแล้ว จึงพิมพ์ไว้เหนือ Grand Total ไม่ใช่ใต้
    // ถ้าไม่มีเศษ (หรือปิดการปัดเศษ) ให้ amount เป็น 0 เพื่อให้ตัวกรองด้านล่างซ่อนบรรทัดนี้ไปเลย
    const roundingAmount =
      roundingType != SETTING_ID.ROUNDING_OPTION_NONE
        ? receiptPayload.payment.rounding
        : 0;

    const round2 = (value: number) => Math.round(value * 100) / 100;
    const taxValue = settingsStore.getValueBysettingId(SETTING_ID.TAX_VALUE, 0);
    // default = true: ก่อนมี setting นี้ ใบเสร็จของร้านที่คิด VAT พิมพ์บรรทัดนี้อยู่แล้ว
    const showBeforeVatSetting = settingsStore.getValueBysettingId(
      SETTING_ID.SHOW_BEFORE_VAT,
      true
    );
    const hasTax = Math.abs(receiptPayload.payment.tax) > 0;

    // grandTotal รวม VAT และเศษไว้แล้ว ถอดทั้งสองออกจึงได้มูลค่าก่อนภาษี
    // VAT แบบ included เก็บ tax เป็นค่าติดลบ (ดู TablesBuilder) จึงต้อง abs ก่อนลบ
    const beforeVat = round2(
      receiptPayload.payment.grandTotal -
        Math.abs(receiptPayload.payment.tax) -
        receiptPayload.payment.rounding
    );

    // ถ้า Before VAT เท่ากับ Total พอดี (ไม่มีค่าบริการ/ส่วนลดมาคั่น) พิมพ์แยกสองบรรทัดก็ได้เลขซ้ำกัน
    // ยุบเป็นบรรทัดเดียวไปเลย เกิดขึ้นได้เฉพาะโหมด VAT แยกนอก
    const mergeBeforeVat =
      showBeforeVatSetting &&
      hasTax &&
      beforeVat === round2(receiptPayload.payment.subTotal);
    const showBeforeVatRow = showBeforeVatSetting && hasTax && !mergeBeforeVat;
    summaryList.push(
      { type: "newline", value: this.customFontSize().newLine },
      { type: "line" },
      {
        type: "text2cols",
        value: mergeBeforeVat ? `Total / Before VAT` : `Total`,
        value2: displayCommaMoney(receiptPayload.payment.subTotal, true),
        amount: receiptPayload.payment.subTotal,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine, amount: receiptPayload.payment.subTotal, },
      {
        type: "text2cols",
        value: `Discount Items`,
        value2: displayCommaMoney(receiptPayload.payment.dc1, true),
        amount: receiptPayload.payment.dc1,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine, amount: receiptPayload.payment.dc1 },
      {
        type: "text2cols",
        value: showServiceChargePercent 
          ? `Service Charge  (${settingsStore.getValueBysettingId(SETTING_ID.SERVICE_CHARGE, 0)}%)`
          : `Service Charge`,
        value2: displayCommaMoney(receiptPayload.payment.sc, true),
        amount: receiptPayload.payment.sc,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine, amount: receiptPayload.payment.sc },
      {
        type: "text2cols",
        value: `Additional Discount`,
        value2: displayCommaMoney(receiptPayload.payment.dc2, true),
        amount: receiptPayload.payment.dc2,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine ,amount: receiptPayload.payment.dc2,},

      {
        type: "text2cols",
        value: `Card Charge  ${
          _cardCharge[0] === 0 ? _cardCharge[1] + "%" : ""
        }`,
        // value2:  receiptPayload.payment.tax[2].toFixed(2),
        value2: displayCommaMoney(receiptPayload.payment.cc, true),
        amount: receiptPayload.payment.cc,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine, amount: receiptPayload.payment.cc },
      {
        type: "text2cols",
        value: `Before VAT`,
        value2: displayCommaMoney(beforeVat, true),
        // amount เป็น 0 = ให้ตัวกรองด้านล่างซ่อนแถวนี้ (ปิด setting / ไม่มี VAT / ยุบไปรวมกับ Total แล้ว)
        amount: showBeforeVatRow ? beforeVat : 0,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      {
        type: "newline",
        value: this.customFontSize().smallNewLine,
        amount: showBeforeVatRow ? beforeVat : 0,
      },
      {
        type: "text2cols",
        value: taxMode == 1 ? `VAT (${taxValue}% Inc.)` : `VAT (${taxValue}% Exc.)`,
        // value2:  receiptPayload.payment.tax[2].toFixed(2),
        value2: displayCommaMoney( Math.abs(receiptPayload.payment.tax), true),
        amount: receiptPayload.payment.tax,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine, amount: receiptPayload.payment.tax },
      {
        type: "text2cols",
        value: `Rounding`,
        value2: displayCommaMoney(receiptPayload.payment.rounding, true),
        amount: roundingAmount,
        style: {
          fontFamily: "Arial",
          fontSize: this.customFontSize().main,
          fontStyle: "normal",
        },
      },
      { type: "newline", value: this.customFontSize().smallNewLine, amount: roundingAmount },

      {
        type: "text2cols",
        value: `Grand Total`,
        value2: `*** ${displayCommaMoney(
          receiptPayload.payment.grandTotal,
          true
        )}`,
        style: {
          fontFamily: "Arial",
          fontSize: 14,
          fontStyle: "bold",
        },
      },
      { type: "doubleline" }
    );

    // summaryList = _.filter(summaryList, s => s.value2 != '0.00')
    summaryList = _.filter(summaryList, (s) => s.amount !== 0);

    // loop summaryList to push
    _.forEach(summaryList, (s) => {
      content.push(s);
    });

  }

  openDrawer() {
    let paylaod = {
      printerPreset: "0",
    };
    axios
      .post(this.apiUrl + this.path + "/opendrawer", paylaod)
      .then((response: AxiosResponse) => {
      })
      .catch((error) => {
        console.log(error);
      });
  }

  renderReceivePayment(content, receiptPayload) {
    //Title Receive Payments

    //Payment Items. 2
    for(let i = 0; i < receiptPayload.payment.list.length; i++){
      let payment = receiptPayload.payment.list[i];
      content.push(       
        {
          type: "text2cols",
          value: `Received (${payment.name})`,
          value2: displayCommaMoney(payment.amount, true),
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().main,
            fontStyle: "normal",
          },
      });

      //เพิ่มบรรทัดก็ต่อเมื่อมีกว่ากว่า 1 รายการและไม่เป็นรายการสุดท้าย
      if(receiptPayload.payment.list.length > 1 && receiptPayload.payment.list.length-1 !== i){
        content.push({type: "newline", value: this.customFontSize().smallNewLine});
      }
    };
  }

  renderReceiptCopy(content, isCopy = false) {
    if (isCopy) {
      content.push(
        {
          type: "text",
          value: `*** Copy ***`,
          style: {
            fontFamily: "Arial",
            fontSize: this.customFontSize().main,
            fontStyle: "bold",
            align: "center",
          },
        },
        {
          type: "newline",
          value: "14",
        }
      );
    }
  }

  async _renderPrintQrCode(content, receipt) {
    const settingsStore = useSettingsStore();
    const qrSetting = settingsStore.getValueBysettingId(
      SETTING_ID.QR_PROMTPAY,
      false
    );

    const usePrompay = await promptpay(
      "promtpay",
      qrSetting.id,
      qrSetting.name,
      receipt.payment.grandTotal
    );
    const qrBase64 = usePrompay.split(",");

    if (qrSetting.active) {
      content.push({
        type: "image",
        value: `${qrBase64 && qrBase64[1]}`,
        style: {
          scale: 0.8,
        },
      });
    }
  }

  _checkAndRemoveEmptyLine(content) {
    return _.filter(content, (c) => {
      if (c.replaceId && !c.value) {
        return false;
      }
      return true;
    });
  }

  // ต่อท้ายชื่อโต๊ะด้วยเลขบิลเฉพาะตอนแยกบิล
  //
  // ใบเสร็จที่ปิดก่อน 2026-08-18 ไม่มี `bill` ระดับบิลเลย เพราะตอนนั้น withBill()
  // ถูกเรียกด้วย undefined เมื่อไม่ได้แยกบิล แล้วมัน return ทิ้งไปเฉย ๆ
  // ค่า default `bill: 'all'` เพิ่งมาทีหลัง เปิดใบเก่ามากด reprint จึงได้
  // "โต๊ะ-undefined" ออกมา ตรงนี้เลยต้องรับกรณีไม่มีค่าด้วย
  billSuffix(bill) {
    if (bill === undefined || bill === null || bill === "" || bill === "all") {
      return "";
    }
    return `-${bill}`;
  }

  showReceiptTime(date) {
    return dayjs(date).format("HH:mm");
  }

  customFontSize(_fontSize = null) {
        const settingsStore = useSettingsStore();
        const customFontSize = settingsStore.getValueBysettingId(SETTING_ID.PRINTER_RECEIPT_FONT_SIZE, 11);
        const fontSize = _fontSize || transfromFontSize("receipt", customFontSize)     

        return {
            main:fontSize,
            sub:Math.ceil(parseFloat(fontSize) * 0.70), //70%
            newLine:Math.ceil(parseFloat(fontSize) * 0.3), //30%
            smallNewLine:Math.ceil(parseFloat(fontSize) * 0.10), //10%
            extraSmallNewLine:Math.ceil(parseFloat(fontSize) * 0.05), //5%
        }
    }  

  // คืนค่า true เมื่อมีการวาดรูปลงใบเสร็จจริง เพื่อให้ผู้เรียกรู้ว่าต้องพิมพ์ข้อความแทนหรือไม่
  async renderImage(content, settingId, scale = 0.5, newLine = "150") {
    try{  
      const settingsStore = useSettingsStore();
      const imageSetting = settingsStore.getValueBysettingId(settingId, "");
      if (imageSetting && imageSetting.url) {        
        const imageBase64 = await convertImgUrlToBase64(imageSetting.url);
        const splited = imageBase64.split(",");
        content.push(
          {
            type: "image",
            value: (splited && splited[1]) || ``,
            style: {
              scale: scale,
            },
          },
          {
            type: "newline",
            value: newLine,
          }
        );
        return true;
      }
    }catch(error: any){           
      console.error("Error in renderImage:", settingId,  error);
    }
    return false;
  }
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { ThermalPrinterReceipt };
